import React, { useState, useEffect } from "react";
import "../style/Description.css";
import {
  Button,
  CircularProgress,
  Grid,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import zillowLogo from "../images/logo003.png";
import GridViewIcon from "@mui/icons-material/GridView";
import appStoreBadge from "../images/app-store-badge.svg";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import FooterImage from "../images/footer-art.svg";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ModeEditOutlineIcon from "@mui/icons-material/ModeEditOutline";
import CreateRoundedIcon from "@mui/icons-material/CreateRounded";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import CalculateIcon from "@mui/icons-material/Calculate";
import currencyFormatter from "currency-formatter";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import AirportShuttleOutlinedIcon from "@mui/icons-material/AirportShuttleOutlined";
import BuyerAgent from "../images/buyer-agent.svg";
import FactsAndFeatures from "./FactsAndFeatures";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import CalculateOutlinedIcon from "@mui/icons-material/CalculateOutlined";
import DirectionsRunOutlinedIcon from "@mui/icons-material/DirectionsRunOutlined";
import DirectionsBikeOutlinedIcon from "@mui/icons-material/DirectionsBikeOutlined";
import DirectionsBusOutlinedIcon from "@mui/icons-material/DirectionsBusOutlined";
import BalanceIcon from "@mui/icons-material/Balance";
import moment from "moment";
import Chart from "react-google-charts";
import useStyles from "./DetailedView.styles";
import ContactAgent from "./ContactAgent";

const PieChartData = [
  ["Task", "Hours per Day"],
  ["Principal & interest", 3324],
  ["All taxes & insurance", 939],
  ["HOA fees", 611],
];
const PieChartOptions = {
  // title: "My Daily Activities",
};
const priceHistory = [
  {
    date: "08/02/2024",
    event: "Listed for sale",
    price: {
      propertyPrice: "$699,000",
      propertyPriceChange: "+7.5%",
      pricePerSqft: "$747",
    },
    source: "MLSListings Inc #ML81974547",
    report_url: "https://google.com",
  },
  {
    date: "08/02/2024",
    event: "Listed for sale",
    price: {
      propertyPrice: "$699,000",
      propertyPriceChange: "+7.5%",
      pricePerSqft: "$747",
    },
    source: "MLSListings Inc #ML81974547",
    report_url: "https://google.com",
  },
  {
    date: "08/02/2024",
    event: "Listed for sale",
    price: {
      propertyPrice: "$699,000",
      propertyPriceChange: "+7.5%",
      pricePerSqft: "$747",
    },
    source: "MLSListings Inc #ML81974547",
    report_url: "https://google.com",
  },
  {
    date: "08/02/2024",
    event: "Listed for sale",
    price: {
      propertyPrice: "$699,000",
      propertyPriceChange: "+7.5%",
      pricePerSqft: "$747",
    },
    source: "MLSListings Inc #ML81974547",
    report_url: "https://google.com",
  },
  {
    date: "08/02/2024",
    event: "Listed for sale",
    price: {
      propertyPrice: "$699,000",
      propertyPriceChange: "+7.5%",
      pricePerSqft: "$747",
    },
    source: "MLSListings Inc #ML81974547",
    report_url: "https://google.com",
  },
  {
    date: "08/02/2024",
    event: "Listed for sale",
    price: {
      propertyPrice: "$699,000",
      propertyPriceChange: "+7.5%",
      pricePerSqft: "$747",
    },
    source: "MLSListings Inc #ML81974547",
    report_url: "https://google.com",
  },
  {
    date: "08/02/2024",
    event: "Listed for sale",
    price: {
      propertyPrice: "$699,000",
      propertyPriceChange: "+7.5%",
      pricePerSqft: "$747",
    },
    source: "MLSListings Inc #ML81974547",
    report_url: "https://google.com",
  },
];

const publicTaxHistory = [
  {
    year: "2023",
    propertyTaxes: {
      price: "$3,798",
      change: "+0.7%",
    },
    taxAssessment: {
      price: "	$253,122",
      change: "+2%",
    },
  },
  {
    year: "2023",
    propertyTaxes: {
      price: "$3,798",
      change: "+0.7%",
    },
    taxAssessment: {
      price: "	$253,122",
      change: "+2%",
    },
  },
  {
    year: "2023",
    propertyTaxes: {
      price: "$3,798",
      change: "+0.7%",
    },
    taxAssessment: {
      price: "	$253,122",
      change: "+2%",
    },
  },
  {
    year: "2023",
    propertyTaxes: {
      price: "$3,798",
      change: "+0.7%",
    },
    taxAssessment: {
      price: "	$253,122",
      change: "+2%",
    },
  },
  {
    year: "2023",
    propertyTaxes: {
      price: "$3,798",
      change: "+0.7%",
    },
    taxAssessment: {
      price: "	$253,122",
      change: "+2%",
    },
  },
  {
    year: "2023",
    propertyTaxes: {
      price: "$3,798",
      change: "+0.7%",
    },
    taxAssessment: {
      price: "	$253,122",
      change: "+2%",
    },
  },
  {
    year: "2023",
    propertyTaxes: {
      price: "$3,798",
      change: "+0.7%",
    },
    taxAssessment: {
      price: "	$253,122",
      change: "+2%",
    },
  },
  {
    year: "2023",
    propertyTaxes: {
      price: "$3,798",
      change: "+0.7%",
    },
    taxAssessment: {
      price: "	$253,122",
      change: "+2%",
    },
  },
  {
    year: "2023",
    propertyTaxes: {
      price: "$3,798",
      change: "+0.7%",
    },
    taxAssessment: {
      price: "	$253,122",
      change: "+2%",
    },
  },
];
const NearbySchool = [
  {
    rating: "4",
    school_name: "Mariano Castro Elementary School",
    grades: "K-5",
    distance: "0.3 min",
  },
  {
    rating: "4",
    school_name: "Mariano Castro Elementary School",
    grades: "K-5",
    distance: "0.3 min",
  },
  {
    rating: "4",
    school_name: "Mariano Castro Elementary School",
    grades: "K-5",
    distance: "0.3 min",
  },
  {
    rating: "4",
    school_name: "Mariano Castro Elementary School",
    grades: "K-5",
    distance: "0.3 min",
  },
  {
    rating: "4",
    school_name: "Mariano Castro Elementary School",
    grades: "K-5",
    distance: "0.3 min",
  },
];
const Description = ({ propertyId }) => {
  const [details, setDetails] = useState(null);
  const [showAll, setShowAll] = useState(false);
  const [showSpecialText, setShowSpecialText] = useState(false);
  const [remainingPhotos, setRemainingPhotos] = useState(0);

  const [isExpanded, setIsExpanded] = useState(false);
  const [isFooterExpanded, setIsFooterExpanded] = useState(false);
  const classes = useStyles();
  const handleToggle = () => {
    setIsExpanded((prevState) => !prevState);
  };
  const handleFooterToggle = () => {
    setIsFooterExpanded((prevState) => !prevState);
  };
  useEffect(() => {
    fetch(`http://localhost:8080/property/get?zipid=${propertyId}`, {
      headers: {
        // Accept: "*/*",
        "Content-Type": "application/json",
      },
      // mode:"no-cors",

      method: "POST",
    })
      .then((res) => {
        // if (!res.ok) {
        //   throw new Error("Network response was not ok");
        // }
        return res.json();
      })
      .then((data) => {
        console.log("Data from server:", data);
        setDetails(data);
        if (data?.data?.images) {
          setRemainingPhotos(data.data.images.length - 5); // Calculate remaining photos
        }
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Access-Control-Allow-Origin", "*");
    myHeaders.append("Access-Control-Allow-Headers", "*");

    const raw = JSON.stringify({
      queryStringParameters: {
        zipid: "2086719822",
      },
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
      mode: "no-cors",
    };
    // const func1 = async  () => {
    //   const response = await fetch("https://a6ezqavvz0.execute-api.ap-south-1.amazonaws.com/v1/estate", {
    //     method:"POST",
    //     body:JSON.stringify({
    //       "queryStringParameters": {
    //         "zipid": "2086719822_zid"
    //       }
    //     }),
    //       mode:"no-cors",
    //       headers: {
    //         "Content-Type":"application/json",
    //         "access-control-allow-origin" : "*"

    //       },
    //       credentials: 'include',
    //   })
    //     // .then((response) => response.json())
    //     console.log("response", response);
    //   return response
    // }
    // func1()
    // .then((result) => console.log("result", result))
    // .catch((error) => console.error("error", error ));
  }, []);

  const handleToggleShowAll = () => {
    setShowAll(!showAll);
    setRemainingPhotos(details.data.images.length - 5);
  };

  const handleToggleSpecialText = () => {
    setShowSpecialText(!showSpecialText);
  };

  // if (!details) {
  //   return <div><CircularProgress /> </div>;
  // }

  const specialText =
    details?.data?.description ||
    "This 3 bedroom, 2 bath home is located in Mountain View's all-age community of Sahara Village! The home has been updated with central A/C; upgraded electrical to 100 Amp; plank floors in the living room, kitchen, hallway, and guest bathroom; carpet replaced in 2018; dual pane windows; newer roof; closet system in master bedroom via Elfa Container Store; and new blinds throughout with the addition of blackout shades in the second bedroom and back room. Upgraded features in the kitchen include quartz counters, subway tile backsplash, KitchenAid appliances, and refinished cabinets with high-quality paint and new hardware. All bedrooms are a comfortable size with plenty of closet space. The master bedroom has an additional back room (permitted) that can be used as a home office, nursery, or craft room. Situated at the end of the park, quiet location on a kind of cul de sac. Very desirable park. Great park location. Easy commute to 85, 237 and 101. Near Hospital, Tech companies and shopping areas.";
  function formatPrice(price) {
    let priceStr = price.toString();

    // Remove .0 if it is at the end
    if (priceStr.endsWith(".0")) {
      priceStr = priceStr.slice(0, -2);
    }

    return priceStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return (
    <>
      {!details ? (
        <div className="property-detail-loader">
          <CircularProgress />
        </div>
      ) : (
        <>
          <div className="description-root">
            <div className="image-grid">
              {details.data && details.data.images
                ? details.data.images.slice(0, 5).map((image, imgIndex) => (
                    <div
                      className={`image-item ${imgIndex === 0 ? "large" : ""}`}
                      key={imgIndex}
                    >
                      <img src={image.url} alt={`Image ${imgIndex + 1}`} />
                    </div>
                  ))
                : [1, 2, 3, 4, 5].map((_, imgIndex) => (
                    <div
                      className={`image-item ${imgIndex === 0 ? "large" : ""}`}
                      key={imgIndex}
                    >
                      <img
                        src="/path/to/static/image.png"
                        alt={`Static Image ${imgIndex + 1}`}
                      />
                    </div>
                  ))}
              <button
                className="show-more-button"
                onClick={handleToggleShowAll}
              >
                <GridViewIcon className="show-more-icon" />
                {showAll ? "Show Less" : `Show All ${remainingPhotos} Photos`}
              </button>
            </div>
            <div className="property-info">
              <div className="property-details">
                <div className="property-details-block-1">
                  <div>
                    <h1>
                      {currencyFormatter.format(details?.data?.price, {
                        code: details?.data?.currency,
                      }) || "269,000"}
                    </h1>
                    <p>
                      {details.data?.address ||
                        "191 E El Camino Real SPC 149, Mountain View, CA 94040"}
                    </p>
                  </div>

                  <div className="property-summary">
                    <p>
                      <span className="property-value">
                        {details.data?.bedrooms.replace(".0", "") || "3"}
                      </span>{" "}
                      <span className="property-unit">beds</span>
                    </p>
                    <p>
                      <span className="property-value">
                        {details.data?.bathrooms.replace(".0", "") || "2"}
                      </span>{" "}
                      <span className="property-unit"> baths</span>
                    </p>
                    <p>
                      {" "}
                      <span className="property-value">
                        {" "}
                        {details.data?.livingarea || "1,000"}
                      </span>{" "}
                      <span className="property-unit">sqft</span>
                    </p>
                  </div>
                </div>
                <div className="estimation">
                  <div className="estimation-content">
                    <span className="est-value">
                      <p>Est.</p>
                      {details.data?.monthlycost || "$1,710/mo"}
                      <InfoOutlinedIcon className="edit-icon" />
                    </span>
                    <span className="get-prequalified-text">
                      Get pre-qualified
                    </span>
                  </div>
                </div>

                <div className="additional-details">
                  <p>
                    {details.data?.propertytype || "Double Wide Mobile Home"}
                  </p>
                  <p>
                    {details.data?.yearbuilt
                      ? `Built in ${details.data.yearbuilt}`
                      : "Built in 1964"}
                  </p>
                  <p>{details.data?.lotarea || "-- sqft lot"}</p>
                  <p>{details.data?.zestimate || "$268,300 Zestimate®"}</p>
                  <p>{details.data?.pricepersqft || "$269/sqft"}</p>
                  <p>{details.data?.hoa || "$-- HOA"}</p>
                </div>
                <hr />
                <br />
                <h2>What's special</h2>
                <p className="special-text">
                  {showSpecialText
                    ? specialText
                    : `${specialText.substring(0, 200)}`}
                </p>
                <span className="toggle-text" onClick={handleToggleSpecialText}>
                  <span className={`arrow ${showSpecialText ? "down" : "up"}`}>
                    <KeyboardArrowUpIcon />
                  </span>
                  {showSpecialText ? "Hide " : "Show More "}
                </span>

                {/* Additional Information Section */}
                <div className="additional-info">
                  <div className="info-item">
                    {details.data?.daysonzillow && (
                      <>
                        <span>
                          <strong>
                            {details.data?.daysonzillow || "22 days on Zillow"}
                          </strong>
                        </span>{" "}
                        days on Zillow{" "}
                      </>
                    )}
                    {details.data?.daysonzillow && details.data?.views && (
                      <>|</>
                    )}
                    {details.data?.views && (
                      <>
                        <span>
                          {" "}
                          <strong>
                            {details.data?.views || "2,308 views"}
                          </strong>{" "}
                          views{" "}
                        </span>
                      </>
                    )}
                    {details.data?.views && details.data?.saves && <>|</>}
                    {details.data?.saves && (
                      <>
                        <span>
                          {" "}
                          <strong> {details.data?.saves || "85"}</strong> saves
                        </span>
                      </>
                    )}
                  </div>
                  <div className="info-item">
                    <span>
                      {details.data?.lastChecked ||
                        "Zillow last checked: 15 hours ago"}
                    </span>
                  </div>
                  <div className="info-item">
                    <span>
                      {details.data?.listingUpdated ||
                        "Listing updated: July 28, 2024 at 08:25pm"}
                    </span>
                  </div>
                  <div className="info-item">
                    <span>
                      {details.data?.listedBy ||
                        "Listed by: Francis Rolland 00896319 650-224-4817, Coldwell Banker Realty"}
                    </span>
                  </div>
                  <div className="info-item">
                    <span>
                      {details.data?.source ||
                        "Source: MLSListings Inc, MLS#: ML81972320"}
                    </span>
                  </div>
                </div>

                {/* Map Section */}
                <div className="map-section">
                  {/* <h2>Map</h2> */}

                  <iframe
                    title="property-location-map"
                    src={
                      details.data?.mapLink ||
                      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3169.6350962406423!2d-122.09449262501586!3d37.398461033749435!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808fb0b6d366055d%3A0x5ae4327074bab503!2s215%20Lauella%20Ct%2C%20Mountain%20View%2C%20CA%2094041%2C%20USA!5e0!3m2!1sen!2sin!4v1722417564319!5m2!1sen!2sin"
                    }
                    width="600"
                    height="320"
                    style={{ border: 0 }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>

                {/* Travel Section */}
                <div className="travel-section">
                  <h2>Travel times</h2>
                  <div className="add-destination">
                    {/* <input  type="text" placeholder="Add a destination" /> */}
                    <TextField
                      className="add-destination-field"
                      type="text"
                      placeholder="Add a destination"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <AirportShuttleOutlinedIcon className="van-icon" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                  <div className="affordability">
                    <h3>Curious what you can afford?</h3>
                    <p>
                      Get pre-qualified with us in as little as 3 minutes, or
                      estimate your budget with this Affordability Calculator.
                      <br />
                    </p>
                    <button className="prequalify-button">Pre-Qualify</button>
                    <button className="calculate-button">Calculate now</button>
                    <span>An equal housing lender. NMLS #10287.</span>
                  </div>
                  <div className="tour-section">
                    <img alt="buyer-agent" src={BuyerAgent} />
                    <h3>Tour with a buyer’s agent</h3>
                    <p>
                      We’ll find a local expert to take you on a private tour of
                      215 Lauella Ct.
                    </p>
                    <p>
                      <strong>Next available tour time: Today at 11am</strong>
                    </p>
                  </div>
                  <button className="see-times-button">
                    See all available times
                  </button>
                </div>

                <hr className="feature-seperator" />
                <h2 className="open-house-title">Open Houses</h2>
                <div className="open-house-main">
                  {details?.data?.open_house_info.map((i) => (
                    <>
                      <div className="open-house">
                        <p className="open-house-date">
                          <strong>
                            {moment(i?.open_house_start).format("ddd, MMM D")}
                          </strong>
                        </p>
                        <p className="open-house-time">
                          {moment(i?.open_house_start).format("h:mm A")} -{" "}
                          {moment(i?.open_house_end).format("h:mm A")}
                        </p>
                        <a href="#" className="open-house-cal-link">
                          Add to calender
                        </a>
                      </div>
                    </>
                  ))}
                </div>
                <hr className="feature-seperator" />
                <FactsAndFeatures propertyDetails={details?.data} />
                <h3>Services availability</h3>
                <hr className="feature-seperator" />
                <h2>Make this home a reality</h2>
                <div className="home-to-reality">
                  <Button
                    startIcon={
                      <CreateOutlinedIcon className="home-to-reality-icon" />
                    }
                    className="home-to-reality-btn"
                  >
                    <div className="home-to-reality-txt-block">
                      <h4>Get pre‑qualified</h4>
                      <p>Be ready to make an offer.</p>
                    </div>
                  </Button>
                  <Button
                    startIcon={
                      <CallOutlinedIcon className="home-to-reality-icon" />
                    }
                    className="home-to-reality-btn"
                  >
                    <div className="home-to-reality-txt-block">
                      <h4>Connect with an agent</h4>
                      <p>Get info on this home, tour, and more.</p>
                    </div>
                  </Button>
                  <Button
                    startIcon={
                      <CalculateOutlinedIcon className="home-to-reality-icon" />
                    }
                    className="home-to-reality-btn"
                  >
                    <div className="home-to-reality-txt-block">
                      <h4>Calculate monthly payment</h4>
                      <p>See if you can afford this home.</p>
                    </div>
                  </Button>
                </div>

                <hr className="feature-seperator" />
                <h2>Estimated market value</h2>
                <div className="emv">
                  <div className="emv-block">
                    <p className="emv-title">Zestimate</p>
                    <p>$293,469</p>
                  </div>
                  <div className="emv-block">
                    <p className="emv-title">Estimated sales range</p>
                    <p>$293,469 - $19837</p>
                  </div>
                  <div className="emv-block">
                    <p className="emv-title">Rent Zestimate®</p>
                    <p>$293/month</p>
                  </div>
                </div>
                <h2>Zestimate® history</h2>
                <p>-14% in last 4 years</p>
                <h2>Price history</h2>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Date</TableCell>
                      <TableCell>Event</TableCell>
                      <TableCell>Price</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {priceHistory.map((i) => (
                      <>
                        <span>
                          Source: {i?.source} <a href={i?.report_url}>Report</a>
                        </span>
                        <TableRow>
                          <TableCell>{i.date}</TableCell>
                          <TableCell>{i.event}</TableCell>
                          <TableCell>
                            <span>
                              {i.price?.propertyPrice}{" "}
                              {i?.price?.propertyPriceChange}
                            </span>
                            <span>{i?.price?.pricePerSqft}/sqft</span>
                          </TableCell>
                        </TableRow>
                      </>
                    ))}
                  </TableBody>
                </Table>
                <h2>Public tax history</h2>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Year</TableCell>
                      <TableCell>Property taxes</TableCell>
                      <TableCell>Tax assessment</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {publicTaxHistory.map((i) => (
                      <>
                        <TableRow>
                          <TableCell>{i?.year}</TableCell>
                          <TableCell>
                            {i?.propertyTaxes.price} {i?.propertyTaxes?.change}
                          </TableCell>
                          <TableCell>
                            {i?.taxAssessment.price} {i?.taxAssessment?.change}
                          </TableCell>
                        </TableRow>
                      </>
                    ))}
                  </TableBody>
                </Table>
                <p>
                  Find assessor info on the <a href="#">county website</a>
                </p>

                <hr className="feature-seperator" />
                <h2 className="monthly-payment-cal-title">
                  Monthly payment calculator
                </h2>
                <div className="monthly-payment-cal-main">
                  <div className="monthly-payment-cal-block-1">
                    <p className="estimate-monnthly-payment">
                      Estimated payment <InfoOutlinedIcon />
                    </p>
                    <p className="monthly-payment-price">$4,943/mo</p>
                    <Button
                      variant="outlined"
                      className="customize-monthly-payment-btn"
                    >
                      Customize this payment
                    </Button>
                  </div>
                  <div className="monthly-payment-cal-block-2">
                    <Chart
                      chartType="PieChart"
                      data={PieChartData}
                      options={PieChartOptions}
                      width={"100%"}
                      height={"10rem"}
                    />
                  </div>
                </div>
                <p className="monthly-payment-note">
                  All calculations are estimates and provided by Zillow, Inc.
                  for informational purposes only. Actual amounts may vary.
                </p>

                <hr className="feature-seperator" />
                <h2 className="down-payment-title">Down payment assistance</h2>
                <div className="down-payment-main">
                  <div>
                    <CalculateIcon className="down-payment-cal-icon" />
                  </div>
                  <div>
                    <p className="down-payment-text">
                      <strong>23 programs</strong> may be available to provide
                      you with <strong>up to $209,700 </strong>in down payment
                      assistance, depending on your specific information.
                    </p>
                    <Button className="down-payment-btn" variant="outlined">
                      Check Eligibility
                    </Button>
                    <p className="down-payment-source-text">
                      Source: Down Payment Resource®
                    </p>
                  </div>
                </div>

                <hr className="feature-seperator" />
                <h2 className="neighborhood-txt">Neighborhood: 94040</h2>
                <div>
                  <p>Map will come here</p>
                </div>

                <hr className="feature-seperator" />
                <h2 className="getting-around-title">Getting around</h2>
                <div className="getting-around-main">
                  <div className="getting-around-tile">
                    <div className="getting-around-icon-block">
                      <DirectionsRunOutlinedIcon className="getting-around-icon" />
                    </div>
                    <div className="getting-around-info-block">
                      <p className="getting-around-score-title">Walk Score®</p>
                      <p className="getting-around-review-score">75 / 100</p>
                      <p className="getting-around-review-txt">Very Walkable</p>
                    </div>
                  </div>
                  <div className="getting-around-tile">
                    <div className="getting-around-icon-block">
                      <DirectionsBusOutlinedIcon className="getting-around-icon" />
                    </div>
                    <div className="getting-around-info-block">
                      <p className="getting-around-score-title">
                        Transit Score®
                      </p>
                      <p className="getting-around-review-score">46 / 100</p>
                      <p className="getting-around-review-txt">Some Transit</p>
                    </div>
                  </div>
                  <div className="getting-around-tile">
                    <div className="getting-around-icon-block">
                      <DirectionsBikeOutlinedIcon className="getting-around-icon" />
                    </div>
                    <div className="getting-around-info-block">
                      <p className="getting-around-score-title">Bike Score®</p>
                      <p className="getting-around-review-score"> 99 / 100</p>
                      <p className="getting-around-review-txt">
                        Biker's Paradise
                      </p>
                    </div>
                  </div>
                </div>

                <hr className="feature-seperator" />
                <h2 className="nearby-schools-title">Nearby schools</h2>
                <div className="nearby-schools-main">
                  <div className="nearby-schools-block-1">
                    <h3 className="school-rating-title">GreatSchools rating</h3>
                    <div className="near-by-schools-list">
                      {NearbySchool.map((i) => (
                        <div className="nearby-school">
                          <div className="school-rating-score-block">
                            <p className="school-rating-score">
                              <span>{i?.rating}</span>/10
                            </p>
                          </div>
                          <div>
                            <p className="school-name">{i?.school_name}</p>
                            <div className="nearby-school-info-block">
                              <p>
                                Grades: <strong>{i?.grades}</strong>
                              </p>{" "}
                              <p>
                                Distance: <strong>{i?.distance}</strong>
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="nearby-schools-block-2">
                    <h3 className="school-listed-by-agent">
                      Schools provided by the listing agent
                    </h3>
                    <p>
                      District: <strong>MountainViewWhisman</strong>
                    </p>
                    <p>
                      Source: MLSListings Inc. This data may not be complete. We
                      recommend contacting the local school district to confirm
                      school assignments for this home.
                    </p>
                  </div>
                </div>

                <hr className="feature-seperator" />
                <>
                  <>
                    <Grid container>
                      <Grid item xs={7}>
                        <h2 className="local-experts-title">
                          Local experts in 12309
                        </h2>
                        <p className="local-experts-text">
                          A local agent can set up tours, give advice and
                          negotiate with sellers.
                        </p>
                        <img
                          className="localexpert-img"
                          src="./img/agent1.jpg"
                          alt="agent"
                        />
                        <img
                          className="localexpert-img"
                          src="./img/agent1.jpg"
                          alt="agent"
                        />
                        <img
                          className="localexpert-img"
                          src="./img/agent1.jpg"
                          alt="agent"
                        />
                        <h4 className="browse-experts-btn">
                          Browse local experts
                        </h4>
                      </Grid>
                      <Grid item className="a-tag-footer"></Grid>
                    </Grid>
                  </>
                </>

                {/* hr  */}

                <hr className="feature-seperator" />

                {/* Local legal protections  */}

                <>
                  <>
                    <h2 className="local-legals-title">
                      Local legal protections
                    </h2>
                    <div className="local-legal-main">
                      <BalanceIcon className="local-legal-balance-icon" />
                      <p className="local-legal-txt">
                        Current legal protections at the state level in New York
                      </p>
                    </div>
                    <h4>
                      <Button
                      // onClick={handleToggle}
                      >
                        {/* {isExpanded ? (
                              <KeyboardArrowUpIcon />
                            ) : (
                              <KeyboardArrowDownIcon />
                            )} */}
                        <span>
                          {" "}
                          {/* {isExpanded ? "Show Less" : "Show More"} */}
                        </span>
                      </Button>
                    </h4>
                  </>
                </>
              </div>
              <ContactAgent propertyData={details.data} />
            </div>
            {showAll && (
              <div className="all-images-popup">
                <div className="popup-content">
                  {details.data?.images.map((image, imgIndex) => (
                    <div className="image-item" key={imgIndex}>
                      <img src={image.url} alt={`Image ${imgIndex + 1}`} />
                    </div>
                  ))}
                  <button
                    className="close-popup-button"
                    onClick={handleToggleShowAll}
                  >
                    Close
                  </button>
                </div>
              </div>
            )}

            <div className="content-container">
              <h3>Nearby Cities</h3>
              <div className="footer-links">
                <Grid className="container-style" container>
                  <Grid item sm={4} md className="blue-color">
                    <Grid container style={{ display: "block" }}>
                      <Grid item className="a-tag-footer">Albany Real estate</Grid>
                      <Grid item className="a-tag-footer">Altamont Real estate</Grid>
                      <Grid item className="a-tag-footer">Cohoes Real estate</Grid>
                    </Grid>
                  </Grid>
                  <Grid item sm={4} md className="blue-color">
                    <Grid container style={{ display: "block" }}>
                      <Grid item className="a-tag-footer">Delmar Real estate</Grid>
                      <Grid item className="a-tag-footer">Glenmont Real estate</Grid>
                      <Grid item className="a-tag-footer">Latham Real estate</Grid>
                    </Grid>
                  </Grid>
                  <Grid item sm={4} md className="blue-color">
                    <Grid container style={{ display: "block" }}>
                      <Grid item className="a-tag-footer">Schenectady Real estate</Grid>
                      <Grid item className="a-tag-footer">Scotia Real estate</Grid>
                      <Grid item className="a-tag-footer">Slingerlands Real estate</Grid>
                    </Grid>
                  </Grid>
                  <Grid item sm={4} md={3} className="blue-color">
                    <Grid container style={{ display: "block" }}>
                      <Grid item className="a-tag-footer">Watervliet Real estate</Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
              {isFooterExpanded && (
                <>
                  <h3 className="nearby-neighborhoods">Nearby neighborhoods</h3>
                  <div className="footer-links">
                    <Grid className="container-style" container>
                      <Grid item sm={4} md className="blue-color">
                        <Grid container style={{ display: "block" }}>
                          <Grid item className="a-tag-footer">Bellevue Real estate</Grid>
                          <Grid item className="a-tag-footer">Central State Street Real estate</Grid>
                          <Grid item className="a-tag-footer">Downtown Real estate</Grid>
                        </Grid>
                      </Grid>
                      <Grid item sm={4} md className="blue-color">
                        <Grid container style={{ display: "block" }}>
                          <Grid item className="a-tag-footer">Eastern Avenue Real estate</Grid>
                          <Grid item className="a-tag-footer">Mont Pleasant Real estate</Grid>
                          <Grid item className="a-tag-footer">Northside Real estate</Grid>
                        </Grid>
                      </Grid>
                      <Grid item sm={4} md className="blue-color">
                        <Grid container style={{ display: "block" }}>
                          <Grid item className="a-tag-footer">Old Niskayuna Real estate</Grid>
                          <Grid item className="a-tag-footer">Union Street Real estate</Grid>
                          <Grid item className="a-tag-footer">Vale and Hamilton Hill Real estate</Grid>
                        </Grid>
                      </Grid>
                      <Grid item sm={4} md={3} className="blue-color">
                        <Grid container style={{ display: "block" }}>
                          <Grid item className="a-tag-footer">Woodlawn Real estate</Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </div>
                  <h3 className="nearby-zipcode">Nearby zip codes</h3>
                  <div className="footer-links">
                    <Grid className="container-style" container>
                      <Grid item sm={4} md className="blue-color">
                        <Grid container style={{ display: "block" }}>
                          <Grid item className="a-tag-footer">12027 Real estate</Grid>
                          <Grid item className="a-tag-footer">12252 Real estate</Grid>
                          <Grid item className="a-tag-footer">12302 Real estate</Grid>
                        </Grid>
                      </Grid>
                      <Grid item sm={4} md className="blue-color">
                        <Grid container style={{ display: "block" }}>
                          <Grid item className="a-tag-footer">12303 Real estate</Grid>
                          <Grid item className="a-tag-footer">12304 Real estate</Grid>
                          <Grid item className="a-tag-footer">12305 Real estate</Grid>
                        </Grid>
                      </Grid>
                      <Grid item sm={4} md className="blue-color">
                        <Grid container style={{ display: "block" }}>
                          <Grid item className="a-tag-footer">12306 Real estate</Grid>
                          <Grid item className="a-tag-footer">12307 Real estate</Grid>
                          <Grid item className="a-tag-footer">12308 Real estate</Grid>
                        </Grid>
                      </Grid>
                      <Grid item sm={4} md={3} className="blue-color">
                        <Grid container style={{ display: "block" }}>
                          <Grid item className="a-tag-footer">12309 Real estate</Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </div>
                  <h3 className="schenectady-topics">Other Schenectady Topics</h3>
                  <div className="footer-links">
                    <Grid className="container-style" container>
                      <Grid item sm={4} md className="blue-color">
                        <Grid container style={{ display: "block" }}>
                          <Grid item className="a-tag-footer">Apartments for Rent in 12309</Grid>
                          <Grid item className="a-tag-footer">Houses for Sale in 12309</Grid>
                          <Grid item className="a-tag-footer">Houses for Rent in 12309</Grid>
                        </Grid>
                      </Grid>
                      <Grid item sm={4} md className="blue-color">
                        <Grid container style={{ display: "block" }}>
                          <Grid item >12309 Real Estate</Grid>
                          <Grid item className="a-tag-footer">Schenectady Condos</Grid>
                          <Grid item className="a-tag-footer">Houses for Sale in Schenectady</Grid>
                        </Grid>
                      </Grid>
                      <Grid item sm={4} md className="blue-color">
                        <Grid container style={{ display: "block" }}>
                          <Grid item className="a-tag-footer">Newest Listings in Schenectady</Grid>
                          <Grid item className="a-tag-footer">Schenectady Home Values</Grid>
                          <Grid item className="a-tag-footer">Schenectady Real Estate Agents</Grid>
                        </Grid>
                      </Grid>
                      <Grid item sm={4} md={3} className="blue-color">
                        <Grid container style={{ display: "block" }}>
                          <Grid item className="a-tag-footer">Schenectady Refinance</Grid>
                          <Grid item className="a-tag-footer">Schenectady Mortgage Rates</Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </div>
                </>
              )}
            </div>
            <Button onClick={handleFooterToggle} className="show-more-button">
              {isFooterExpanded ? (
                <KeyboardArrowUpIcon />
              ) : (
                <KeyboardArrowDownIcon />
              )}
              {isFooterExpanded ? "Show Less" : "Show More"}
            </Button>

            <div className="content-container">
              <div>
                <hr />
              </div>
              <div className="footer-links">
                <Grid className="container-style" container>
                  <Grid item sm={4} md className="blue-color">
                    <Grid container style={{ display: "block" }}>
                      <Grid item className="a-tag-bottom-footer">About</Grid>
                      <Grid item className="a-tag-bottom-footer">Zestimates</Grid>
                      <Grid item className="a-tag-bottom-footer">Research</Grid>
                      <Grid item className="a-tag-bottom-footer">Careers</Grid>
                      <Grid item className="a-tag-bottom-footer">Careers - U.S. Privacy Notice</Grid>
                      <Grid item className="a-tag-bottom-footer">Careers - Mexico Privacy Notice</Grid>
                    </Grid>
                  </Grid>
                  <Grid item sm={4} md className="blue-color">
                    <Grid container style={{ display: "block" }}>
                      <Grid item className="a-tag-bottom-footer">Help</Grid>
                      <Grid item className="a-tag-bottom-footer">Advertise</Grid>
                      <Grid item className="a-tag-bottom-footer">Fair Housing Guide</Grid>
                      <Grid item className="a-tag-bottom-footer">Advocacy</Grid>
                      <Grid item className="a-tag-bottom-footer">Terms of use</Grid>
                      <Grid item className="a-tag-bottom-footer">Privacy Portal</Grid>
                    </Grid>
                  </Grid>
                  <Grid item sm={4} md className="blue-color">
                    <Grid container style={{ display: "block" }}>
                      <Grid item className="a-tag-bottom-footer">Cookie Preference</Grid>
                      <Grid item className="a-tag-bottom-footer">Blog</Grid>
                      <Grid item className="a-tag-bottom-footer">AI</Grid>
                      <Grid item className="a-tag-bottom-footer">Mobile Apps</Grid>
                    </Grid>
                  </Grid>
                  <Grid item sm={4} md={3} className="blue-color">
                    <Grid container style={{ display: "block" }}>
                      Trulia
                    </Grid>
                    <Grid container style={{ display: "block" }}>
                      StreetEasy
                    </Grid>
                    <Grid container style={{ display: "block" }}>
                      HotPads
                    </Grid>
                    <Grid container style={{ display: "block" }}>
                      Out East
                    </Grid>
                    <Grid container style={{ display: "block" }}>
                      ShowingTime+
                    </Grid>
                  </Grid>
                </Grid>
                <p className="sell-or-share">
                  Do Not Sell or Share My Personal Information →
                </p>
              </div>
              <div>
                <hr />
              </div>
            </div>

            <div className="footer-content">
              <p className="footer-paragraph">
                Zillow Group is committed to ensuring digital accessibility for
                individuals with disabilities. We are continuously working to
                improve the accessibility of our web experience for everyone,
                and we welcome feedback and accommodation requests. If you wish
                to report an issue or seek an accommodation, please let us know.
              </p>
              <p className="footer-paragraph">
                Zillow, Inc. holds real estate brokerage licenses in multiple
                states. Zillow (Canada), Inc. holds real estate brokerage
                licenses in multiple provinces.
              </p>
              <p className="footer-paragraph">
                § 442-H New York Standard Operating Procedures
              </p>
              <p className="footer-paragraph">§ New York Fair Housing Notice</p>
              <p className="footer-paragraph">
                TREC: Information about brokerage services, Consumer protection
                notice
              </p>
              <p className="footer-paragraph">California DRE #1522444</p>
              <p className="footer-paragraph">Contact Zillow, Inc. Brokerage</p>
              <p className="footer-paragraph">
                For listings in Canada, the trademarks REALTOR®, REALTORS®, and
                the REALTOR® logo are controlled by The Canadian Real Estate
                Association (CREA) and identify real estate professionals who
                are members of CREA. The trademarks MLS®, Multiple Listing
                Service® and the associated logos are owned by CREA and identify
                the quality of services provided by real estate professionals
                who are members of CREA. Used under license.
              </p>
              <div>
                <svg
                  width="96"
                  height="32"
                  viewBox="0 0 96 32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g fill="none">
                    <path
                      d="M88.108 0H7.628c-.294 0-.583 0-.876.002-.245.001-.488.006-.735.01-.537.006-1.073.053-1.603.141-.53.09-1.042.259-1.521.502A5.15 5.15 0 0 0 .155 4.417 10.37 10.37 0 0 0 .012 6.02c-.007.245-.008.491-.012.736v18.492c.004.248.005.489.012.737.006.537.054 1.073.143 1.602a5.27 5.27 0 0 0 .5 1.523c.243.479.561.915.943 1.292.378.381.816.7 1.295.943a5.36 5.36 0 0 0 1.52.504c.53.087 1.067.135 1.604.142.247.005.49.008.735.008.293.002.582.002.876.002h80.48c.287 0 .58 0 .867-.002.244 0 .494-.003.738-.008a10.623 10.623 0 0 0 1.6-.142 5.443 5.443 0 0 0 1.526-.504 5.022 5.022 0 0 0 1.294-.943c.38-.378.7-.814.945-1.292a5.25 5.25 0 0 0 .495-1.523c.09-.53.14-1.065.149-1.602.003-.248.003-.489.003-.737.006-.29.006-.58.006-.875V7.629c0-.293 0-.584-.006-.874 0-.245 0-.49-.003-.736-.01-.537-.06-1.072-.149-1.602a5.294 5.294 0 0 0-.495-1.523A5.173 5.173 0 0 0 92.84.654a5.414 5.414 0 0 0-1.526-.5 10.435 10.435 0 0 0-1.6-.142c-.244-.004-.494-.009-.738-.01C88.687 0 88.395 0 88.108 0z"
                      fill="#2A2A33"
                    />
                    <path
                      d="M6.756 31.3c-.244 0-.482-.003-.724-.009-.5-.006-1-.05-1.495-.13a4.707 4.707 0 0 1-1.325-.438 4.325 4.325 0 0 1-1.118-.814 4.257 4.257 0 0 1-.816-1.117 4.577 4.577 0 0 1-.435-1.326 9.93 9.93 0 0 1-.133-1.5c-.005-.168-.012-.73-.012-.73V6.756s.007-.554.012-.716c.006-.502.05-1.003.133-1.498.076-.463.223-.911.434-1.33A4.452 4.452 0 0 1 4.534.842a9.929 9.929 0 0 1 1.5-.132L6.756.7h82.215l.73.01c.499.006.996.05 1.487.13a4.75 4.75 0 0 1 1.337.439 4.475 4.475 0 0 1 1.932 1.935c.208.416.353.86.428 1.32.083.499.13 1.003.14 1.51.002.226.002.47.002.711.006.3.006.586.006.874v16.743c0 .29 0 .574-.006.86 0 .26 0 .498-.004.744-.009.497-.055.992-.136 1.483-.075.464-.22.915-.432 1.336-.211.41-.485.784-.813 1.108a4.33 4.33 0 0 1-1.12.818 4.69 4.69 0 0 1-1.334.44c-.494.08-.994.124-1.495.13-.234.006-.48.009-.718.009l-.867.002L6.756 31.3z"
                      fill="#FFF"
                    />
                    <path
                      d="M33.841 21.712h-3.786l-.91 2.685h-1.604l3.587-9.935h1.667l3.586 9.935H34.75l-.909-2.685zm-3.394-1.24h3.001l-1.48-4.357h-.04l-1.481 4.358zm13.68.304c0 2.25-1.204 3.697-3.022 3.697a2.455 2.455 0 0 1-2.28-1.268h-.034v3.588h-1.486v-9.64h1.439v1.206h.027a2.57 2.57 0 0 1 2.306-1.28c1.839 0 3.05 1.452 3.05 3.697zm-1.528 0c0-1.467-.758-2.43-1.914-2.43-1.136 0-1.9.984-1.9 2.43 0 1.46.764 2.437 1.9 2.437 1.156 0 1.914-.958 1.914-2.437zm9.5 0c0 2.25-1.204 3.697-3.022 3.697a2.455 2.455 0 0 1-2.28-1.268h-.034v3.588h-1.486v-9.64h1.439v1.206h.027a2.57 2.57 0 0 1 2.306-1.28c1.839 0 3.05 1.452 3.05 3.697zm-1.528 0c0-1.467-.758-2.43-1.914-2.43-1.136 0-1.9.984-1.9 2.43 0 1.46.764 2.437 1.9 2.437 1.156 0 1.914-.958 1.914-2.437zm6.797.853c.11.985 1.067 1.632 2.375 1.632 1.253 0 2.154-.647 2.154-1.535 0-.771-.543-1.233-1.831-1.55l-1.287-.31c-1.825-.44-2.672-1.293-2.672-2.678 0-1.714 1.494-2.891 3.615-2.891 2.1 0 3.539 1.177 3.587 2.891h-1.5c-.09-.991-.91-1.59-2.108-1.59-1.197 0-2.017.606-2.017 1.487 0 .702.523 1.116 1.804 1.432l1.094.269c2.039.482 2.885 1.3 2.885 2.754 0 1.858-1.48 3.022-3.835 3.022-2.203 0-3.69-1.136-3.786-2.933h1.522zm9.309-6.19v1.715h1.377v1.177h-1.377v3.993c0 .62.276.91.881.91.164-.003.327-.015.49-.035v1.17c-.273.051-.55.074-.827.07-1.466 0-2.038-.552-2.038-1.956V18.33H64.13v-1.177h1.053V15.44h1.494zm2.174 5.337c0-2.28 1.342-3.711 3.435-3.711 2.1 0 3.436 1.432 3.436 3.71 0 2.286-1.329 3.712-3.436 3.712-2.106 0-3.435-1.426-3.435-3.711zm5.356 0c0-1.563-.716-2.486-1.92-2.486-1.205 0-1.922.93-1.922 2.486 0 1.57.717 2.485 1.921 2.485 1.205 0 1.921-.916 1.921-2.485zm2.741-3.622h1.418v1.233h.034a1.728 1.728 0 0 1 1.743-1.309c.17 0 .342.018.509.056v1.39a2.078 2.078 0 0 0-.668-.09 1.498 1.498 0 0 0-1.55 1.667v4.296h-1.486v-7.243zm10.559 5.116c-.2 1.314-1.48 2.217-3.12 2.217-2.106 0-3.414-1.412-3.414-3.677 0-2.272 1.315-3.745 3.352-3.745 2.004 0 3.264 1.376 3.264 3.572v.51h-5.115v.09a1.886 1.886 0 0 0 1.948 2.051 1.639 1.639 0 0 0 1.673-1.018h1.412zm-5.026-2.162h3.621a1.742 1.742 0 0 0-1.777-1.838 1.834 1.834 0 0 0-1.844 1.838zM30.261 6.985a2.112 2.112 0 0 1 2.246 2.372c0 1.525-.824 2.401-2.246 2.401h-1.724V6.985h1.724zm-.983 4.098h.9a1.5 1.5 0 0 0 1.574-1.717 1.505 1.505 0 0 0-1.574-1.707h-.9v3.424zm4.067-1.128a1.707 1.707 0 1 1 3.397 0 1.707 1.707 0 1 1-3.397 0zm2.666 0c0-.78-.35-1.237-.966-1.237-.618 0-.966.457-.966 1.237 0 .788.348 1.24.966 1.24.615 0 .966-.456.966-1.24zm5.248 1.803h-.738l-.744-2.653h-.057l-.741 2.653h-.73l-.994-3.602h.722l.645 2.749h.053l.74-2.75h.683l.74 2.75h.057l.642-2.75h.71l-.988 3.603zm1.824-3.602h.684v.572h.053a1.08 1.08 0 0 1 1.075-.642 1.172 1.172 0 0 1 1.247 1.34v2.332h-.71V9.605c0-.58-.252-.867-.778-.867a.826.826 0 0 0-.86.913v2.107h-.711V8.156zm4.192-1.406h.711v5.008h-.711V6.75zm1.7 3.205a1.707 1.707 0 1 1 3.397 0 1.707 1.707 0 1 1-3.398 0zm2.666 0c0-.78-.351-1.237-.967-1.237-.618 0-.965.457-.965 1.237 0 .788.347 1.24.965 1.24.616 0 .967-.456.967-1.24zm1.48.784c0-.648.483-1.022 1.34-1.075l.975-.056v-.311c0-.38-.251-.595-.737-.595-.397 0-.672.145-.75.4h-.69c.073-.619.655-1.016 1.473-1.016.903 0 1.412.45 1.412 1.21v2.462h-.684v-.506h-.056c-.233.37-.646.586-1.082.566a1.088 1.088 0 0 1-1.201-1.079zm2.315-.307v-.302l-.88.057c-.495.033-.72.202-.72.52 0 .323.28.512.668.512a.85.85 0 0 0 .932-.787zm1.643-.477c0-1.138.585-1.859 1.495-1.859.46-.021.89.225 1.105.632h.053V6.75h.71v5.008h-.68v-.569h-.057a1.25 1.25 0 0 1-1.131.629c-.917 0-1.495-.722-1.495-1.863zm.734 0c0 .765.36 1.224.962 1.224.6 0 .97-.466.97-1.22 0-.751-.374-1.224-.97-1.224-.598 0-.962.463-.962 1.22zm5.571 0a1.707 1.707 0 1 1 3.398 0 1.707 1.707 0 1 1-3.398 0zm2.666 0c0-.78-.35-1.237-.966-1.237-.618 0-.966.457-.966 1.237 0 .788.348 1.24.966 1.24.616 0 .966-.456.966-1.24zm1.686-1.8h.684v.573h.053a1.08 1.08 0 0 1 1.075-.642 1.172 1.172 0 0 1 1.247 1.34v2.332h-.711V9.605c0-.58-.252-.867-.777-.867a.826.826 0 0 0-.86.913v2.107h-.711V8.156zm7.076-.896v.913h.78v.6h-.78v1.851c0 .378.156.543.51.543.09 0 .18-.006.27-.016v.592a2.332 2.332 0 0 1-.386.036c-.79 0-1.106-.278-1.106-.973V8.771h-.571v-.599h.571V7.26h.712zm1.752-.51h.704v1.986h.057a1.108 1.108 0 0 1 1.098-.646 1.187 1.187 0 0 1 1.24 1.343v2.326h-.711v-2.15c0-.576-.268-.867-.77-.867a.842.842 0 0 0-.907.913v2.104h-.711V6.75zm7.245 4.037a1.463 1.463 0 0 1-1.56 1.042 1.636 1.636 0 0 1-1.665-1.86 1.661 1.661 0 0 1 1.66-1.882c1.003 0 1.608.685 1.608 1.816v.248h-2.544v.04a.952.952 0 0 0 .96 1.032.863.863 0 0 0 .857-.436h.684zm-2.5-1.161h1.819a.87.87 0 0 0-.887-.934.921.921 0 0 0-.933.934zm-61.312 6.286a4.117 4.117 0 0 1 1.96-3.454 4.214 4.214 0 0 0-3.32-1.795c-1.396-.146-2.75.836-3.463.836-.725 0-1.821-.821-3.002-.797a4.422 4.422 0 0 0-3.72 2.27c-1.61 2.785-.41 6.879 1.132 9.13.77 1.103 1.672 2.335 2.851 2.291 1.154-.048 1.585-.736 2.978-.736 1.38 0 1.784.736 2.987.708 1.239-.02 2.019-1.107 2.763-2.22a9.12 9.12 0 0 0 1.263-2.573 3.978 3.978 0 0 1-2.429-3.66zm-2.272-6.73a4.053 4.053 0 0 0 .927-2.903 4.124 4.124 0 0 0-2.668 1.38 3.857 3.857 0 0 0-.952 2.797 3.41 3.41 0 0 0 2.693-1.274z"
                      fill="#2A2A33"
                    />
                  </g>
                </svg>
                &nbsp; &nbsp; &nbsp;
                <svg
                  width="108"
                  height="32"
                  viewBox="0 0 108 32"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g fill="none">
                    <rect fill="#FFF" width="108" height="32" rx="5" />
                    <path
                      d="M104 .64A3.36 3.36 0 0 1 107.36 4v24a3.36 3.36 0 0 1-3.36 3.36H4A3.36 3.36 0 0 1 .64 28V4A3.36 3.36 0 0 1 4 .64h100zm0-.64H4a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h100a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4z"
                      fill="#2A2A33"
                    />
                    <path
                      d="M54.512 17.4a3.4 3.4 0 1 0 3.416 3.4 3.352 3.352 0 0 0-3.416-3.4zm0 5.464a2.064 2.064 0 1 1 1.92-2.064 1.968 1.968 0 0 1-1.92 2.064zM47.064 17.4a3.4 3.4 0 1 0 3.408 3.4 3.352 3.352 0 0 0-3.416-3.4h.008zm0 5.464a2.064 2.064 0 1 1 1.912-2.064 1.968 1.968 0 0 1-1.92 2.064h.008zm-8.872-4.416v1.44h3.456a3.016 3.016 0 0 1-.8 1.816 3.536 3.536 0 0 1-2.664 1.056 3.84 3.84 0 0 1 0-7.68 3.68 3.68 0 0 1 2.616 1.032l1.016-1.016a5.032 5.032 0 0 0-3.624-1.496 5.288 5.288 0 1 0 0 10.568 4.8 4.8 0 0 0 3.688-1.48 4.8 4.8 0 0 0 1.248-3.376 4.696 4.696 0 0 0-.08-.904l-4.856.04zm36.248 1.12a3.2 3.2 0 0 0-2.912-2.168 3.2 3.2 0 0 0-3.2 3.4 3.328 3.328 0 0 0 3.376 3.4 3.384 3.384 0 0 0 2.832-1.504l-1.16-.8a1.944 1.944 0 0 1-1.672.944 1.728 1.728 0 0 1-1.648-1.032l4.552-1.88-.168-.36zm-4.64 1.136a1.864 1.864 0 0 1 1.776-1.984 1.32 1.32 0 0 1 1.264.72l-3.04 1.264zM66.104 24H67.6V14h-1.496v10zm-2.448-5.84H63.6a2.4 2.4 0 0 0-1.792-.8 3.408 3.408 0 0 0 0 6.808 2.32 2.32 0 0 0 1.792-.8h.048v.488c0 1.304-.696 2-1.816 2a1.88 1.88 0 0 1-1.712-1.208l-1.304.544a3.24 3.24 0 0 0 3.016 2.008c1.752 0 3.2-1.032 3.2-3.544V17.6h-1.376v.56zm-1.712 4.704a2.072 2.072 0 0 1 0-4.128A1.92 1.92 0 0 1 63.76 20.8a1.904 1.904 0 0 1-1.824 2.064h.008zM81.448 14h-3.576v10h1.496v-3.792h2.088a3.112 3.112 0 1 0 0-6.208h-.008zm0 4.8H79.36v-3.408h2.12a1.716 1.716 0 0 1 0 3.432l-.032-.024zm9.224-1.44a2.8 2.8 0 0 0-2.664 1.528l1.328.552c.268-.493.8-.782 1.36-.736a1.44 1.44 0 0 1 1.6 1.288v.104a3.304 3.304 0 0 0-1.56-.384c-1.432 0-2.88.8-2.88 2.248a2.312 2.312 0 0 0 2.48 2.2 2.104 2.104 0 0 0 1.92-.96h.048v.8h1.44v-3.848c0-1.752-1.328-2.768-3.032-2.768l-.04-.024zm-.184 5.48c-.488 0-1.168-.248-1.168-.848 0-.8.848-1.064 1.6-1.064a2.65 2.65 0 0 1 1.36.336 1.808 1.808 0 0 1-1.752 1.6l-.04-.024zm8.504-5.24-1.712 4.336h-.048L95.456 17.6h-1.6l2.664 6.064L95 27.032h1.56l4.096-9.432h-1.664zM85.544 24h1.496V14h-1.496v10zM37.936 8.192a2.168 2.168 0 0 1-.6 1.6 2.328 2.328 0 0 1-1.76.712 2.52 2.52 0 0 1-1.768-4.296 2.4 2.4 0 0 1 1.768-.72 2.48 2.48 0 0 1 .984.2c.29.117.547.3.752.536l-.424.424a1.6 1.6 0 0 0-1.312-.568A1.856 1.856 0 0 0 33.712 8a1.888 1.888 0 0 0 3.2 1.384c.246-.267.388-.613.4-.976h-1.736v-.576h2.328c.021.119.032.24.032.36zm3.664-2h-2.16v1.52h1.968v.576H39.44v1.52h2.16v.592h-2.8V5.6h2.8v.592zm2.624 4.208h-.616V6.192h-1.344V5.6H45.6v.592h-1.376V10.4zm3.728 0V5.6h.616v4.8h-.616zm3.352 0h-.616V6.192h-1.344V5.6h3.296v.592h-1.336V10.4zm7.584-.624a2.496 2.496 0 0 1-3.52 0 2.592 2.592 0 0 1 0-3.56 2.48 2.48 0 0 1 3.52 0 2.584 2.584 0 0 1 0 3.56zm-3.064-.4a1.848 1.848 0 0 0 2.608 0 2.048 2.048 0 0 0 0-2.752 1.848 1.848 0 0 0-2.608 0 2.048 2.048 0 0 0 0 2.752zm4.64 1.024V5.6h.752l2.336 3.736V5.6h.616v4.8h-.64l-2.44-3.912V10.4h-.624zM8.352 6.032a1.6 1.6 0 0 0-.368 1.12v17.696a1.6 1.6 0 0 0 .368 1.12l.056.056 9.912-9.904v-.232L8.408 5.976l-.056.056zM21.6 19.424l-3.28-3.304v-.232l3.28-3.312.072.04 3.928 2.232c1.12.632 1.12 1.672 0 2.312l-3.912 2.224-.088.04z"
                      fill="#2A2A33"
                    />
                    <path
                      d="M21.696 19.376 18.32 16l-9.968 9.968c.471.414 1.17.434 1.664.048l11.688-6.64m-.008-6.752-11.688-6.64a1.304 1.304 0 0 0-1.664.048L18.32 16l3.376-3.376z"
                      fill="#2A2A33"
                    />
                    <path
                      d="m21.6 19.304-11.592 6.6a1.336 1.336 0 0 1-1.6 0l-.056.056.056.056a1.328 1.328 0 0 0 1.6 0l11.688-6.64-.096-.072z"
                      fill="#000"
                      opacity=".2"
                    />
                    <path
                      d="M8.352 25.856a1.6 1.6 0 0 1-.368-1.12v.12a1.6 1.6 0 0 0 .368 1.12l.056-.056-.056-.064zM25.6 17.04l-4 2.264.072.072 3.928-2.224A1.4 1.4 0 0 0 26.4 16a1.488 1.488 0 0 1-.8 1.04z"
                      fill="#000"
                      opacity=".12"
                    />
                    <path
                      d="M10.008 6.096 25.6 14.96c.413.204.709.588.8 1.04a1.4 1.4 0 0 0-.8-1.152L10.008 5.984c-1.12-.632-2.032-.104-2.032 1.176v.12c.024-1.288.92-1.816 2.032-1.184z"
                      fill="#FFF"
                      opacity=".25"
                    />
                    <path stroke="#FFF" d="m8.4 6 14.4 14.4M8.4 26 22 12.4" />
                  </g>
                </svg>
              </div>

              <div>
                <Grid container className="social-links">
                  <Grid item className="a-tag-footer">
                    <img src={zillowLogo} alt="App Store Img" className="footer-logo" />
                  </Grid>
                  <Grid item className="a-tag-footer">
                    <div className="follow-us">
                      <span>Follow us: </span>

                      <div className="follow-us-icons social-icons social-icons-color">
                        <svg
                          viewBox="0 0 32 32"
                          aria-hidden="true"
                          focusable="false"
                          role="img"
                          class="Icon-c11n-8-100-2__sc-13llmml-0 izrthT"
                        >
                          <path
                            stroke="none"
                            d="M30,16.08A14,14,0,1,0,13.81,30V20H10.26V16h3.55V13c0-3.53,2.09-5.48,5.29-5.48a20.46,20.46,0,0,1,3.13.28v3.46H20.47A2,2,0,0,0,18.2,13a1.7,1.7,0,0,0,0,.45V16h3.88l-.62,4H18.19V30A14.06,14.06,0,0,0,30,16.08Z"
                          ></path>
                        </svg>
                        <svg
                          viewBox="0 0 32 32"
                          aria-hidden="true"
                          focusable="false"
                          role="img"
                          class="Icon-c11n-8-100-2__sc-13llmml-0 izrthT"
                        >
                          <g stroke="none">
                            <path d="M21,2H11a9,9,0,0,0-9,9V21a9,9,0,0,0,9,9H21a9,9,0,0,0,9-9V11A9,9,0,0,0,21,2Zm7,19a7,7,0,0,1-7,7H11a7,7,0,0,1-7-7V11a7,7,0,0,1,7-7H21a7,7,0,0,1,7,7Z"></path>
                            <path d="M16,9a7,7,0,1,0,7,7A7,7,0,0,0,16,9Zm0,12a5,5,0,1,1,5-5A5,5,0,0,1,16,21Z"></path>
                            <circle cx="23.5" cy="8.5" r="1.5"></circle>
                          </g>
                        </svg>
                        <svg
                          viewBox="0 0 32 32"
                          aria-hidden="true"
                          focusable="false"
                          role="img"
                          class="Icon-c11n-8-100-2__sc-13llmml-0 izrthT"
                        >
                          <path
                            d="M27.988 9.01a6.774 6.774 0 0 1-4.16-1.424 7.095 7.095 0 0 1-2.616-4.263A7.263 7.263 0 0 1 21.079 2h-4.46v12.492l-.006 6.843c0 1.83-1.162 3.38-2.773 3.926a3.961 3.961 0 0 1-3.345-.377 4.158 4.158 0 0 1-1.973-3.487c-.034-2.313 1.79-4.199 4.045-4.199.445 0 .873.075 1.273.21v-4.641a8.565 8.565 0 0 0-1.286-.098c-2.468 0-4.777 1.052-6.427 2.947a8.687 8.687 0 0 0-2.11 5.173c-.152 2.516.746 4.908 2.489 6.673A8.423 8.423 0 0 0 12.555 30a8.448 8.448 0 0 0 6.048-2.538 8.664 8.664 0 0 0 2.505-6.092l-.024-10.218a11.2 11.2 0 0 0 2.506 1.498 11.03 11.03 0 0 0 4.41.911V9.01h-.012z"
                            stroke="none"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </Grid>
                  <Grid item className="a-tag-footer">
                    <div className="follow-us">
                      <span>© 2006-2024 Zillow </span>
                      <div className="follow-us-icons social-icons social-icons-color">
                        <svg
                          viewBox="0 0 271.2 290.1"
                          aria-hidden="true"
                          focusable="false"
                          role="img"
                          class="Icon-c11n-8-100-2__sc-13llmml-0 izrthT"
                        >
                          <g stroke="none">
                            <path d="M0 126.8V90.3l10.4-7L30 70l19.2-12.7 19.5-13.2 19.1-12.8 18.8-12.6L133.8.5a3.4 3.4 0 0 1 3.6 0l5.8 3.9 13.7 9.3q13.2 9 26.5 17.8l13.8 9.3 27.4 18.4 26.2 17.6 18.4 12.4a17.7 17.7 0 0 1 2 1.8v36h-17.6v107.8H252l-147-.3H19.8a16.2 16.2 0 0 1-2-.3V126.8zm224.4 71v-.7-89.8a1.8 1.8 0 0 0-.8-1.3L198 88.8l-41-27.5L136 47.5a1.2 1.2 0 0 0-1.6 0l-7.8 5.3-18.5 12.4L91 76.8 73.4 88.6l-25.2 16.9a1.9 1.9 0 0 0-1 1.8v90.5z"></path>
                            <path d="M89.1 181v-38.6h93.4V181zM88.9 97.8h93.3v38.5H89z"></path>
                            <path d="M21.4 261v-20.3h14.7v2.4h-12v6.2h11.3v2.4H24v7h12.5v2.3zM55.7 258.9a16.5 16.5 0 0 0 3.5 1.8l-.8 2A15.9 15.9 0 0 1 54 260a10 10 0 0 1-5 1.3 9.6 9.6 0 0 1-5-1.4 8.9 8.9 0 0 1-3.4-3.7 12 12 0 0 1-1.3-5.4 12.2 12.2 0 0 1 1.3-5.5 8.6 8.6 0 0 1 3.4-3.8 10 10 0 0 1 5-1.3 9.8 9.8 0 0 1 5.1 1.4 8.7 8.7 0 0 1 3.5 3.7 12.1 12.1 0 0 1 1.2 5.5 12.6 12.6 0 0 1-.8 4.5 9.5 9.5 0 0 1-2.3 3.5zm-6-3.5a10 10 0 0 1 4 2q2.3-2.2 2.3-6.5a10.3 10.3 0 0 0-.8-4.4 6.5 6.5 0 0 0-2.5-2.8 7 7 0 0 0-8.6 1q-2 2-2 6.2a8.6 8.6 0 0 0 2 6 6.5 6.5 0 0 0 5 2.2 6.9 6.9 0 0 0 2.7-.6 8.7 8.7 0 0 0-2.7-1.1zM75.7 240.7h2.7v11.7a14 14 0 0 1-.7 5 6 6 0 0 1-2.5 2.8 8.9 8.9 0 0 1-4.7 1.2 9.8 9.8 0 0 1-4.7-1 5.6 5.6 0 0 1-2.6-2.9 13.6 13.6 0 0 1-.8-5v-11.8h2.7v11.7a11.4 11.4 0 0 0 .5 4 3.7 3.7 0 0 0 1.7 1.9 5.9 5.9 0 0 0 3 .7q3 0 4.2-1.4t1.2-5.2zM80.7 261l7.8-20.3h2.9l8.3 20.3h-3l-2.4-6.1h-8.5l-2.3 6.1zm5.8-8.3h7l-2.2-5.6q-1-2.6-1.4-4.3a26 26 0 0 1-1.1 4zM101.7 261v-20.3h2.7v18h10v2.3zM124.6 261v-20.3h2.7v8.4h10.5v-8.4h2.7V261h-2.7v-9.6h-10.5v9.6zM144.2 251.1q0-5 2.7-7.9a9.2 9.2 0 0 1 7-2.9 9.7 9.7 0 0 1 5 1.4 8.8 8.8 0 0 1 3.5 3.7 12.2 12.2 0 0 1 1.2 5.5 12 12 0 0 1-1.2 5.5 8.5 8.5 0 0 1-3.6 3.7 10.1 10.1 0 0 1-5 1.3 9.6 9.6 0 0 1-5-1.4 9 9 0 0 1-3.5-3.8 11.5 11.5 0 0 1-1.1-5zm2.7 0a8.1 8.1 0 0 0 2 5.9 6.9 6.9 0 0 0 10 0 8.6 8.6 0 0 0 2-6.1 10.4 10.4 0 0 0-.9-4.4 6.4 6.4 0 0 0-2.5-2.8 6.7 6.7 0 0 0-3.6-1 6.9 6.9 0 0 0-4.9 2q-2 1.9-2 6.5zM180.4 240.7h2.7v11.7a14 14 0 0 1-.7 5 6 6 0 0 1-2.5 2.8 8.9 8.9 0 0 1-4.7 1.2 9.8 9.8 0 0 1-4.7-1 5.6 5.6 0 0 1-2.6-2.9 13.6 13.6 0 0 1-.8-5v-11.8h2.7v11.7a11.4 11.4 0 0 0 .5 4 3.7 3.7 0 0 0 1.7 1.9 5.9 5.9 0 0 0 3 .7q2.9 0 4.2-1.4t1.2-5.2zM186.7 254.5l2.5-.2a5.6 5.6 0 0 0 .9 2.5 4.6 4.6 0 0 0 2 1.6 7.7 7.7 0 0 0 3.1.6 7.5 7.5 0 0 0 2.7-.5 3.8 3.8 0 0 0 1.8-1.2 3 3 0 0 0 .6-1.8 2.6 2.6 0 0 0-.6-1.7 4.1 4.1 0 0 0-1.8-1.2 35.7 35.7 0 0 0-3.6-1 18.4 18.4 0 0 1-4-1.2 5.5 5.5 0 0 1-2.1-2 4.6 4.6 0 0 1-.7-2.4 5.2 5.2 0 0 1 .8-3 5.4 5.4 0 0 1 2.6-2 9.7 9.7 0 0 1 3.7-.6 10.2 10.2 0 0 1 4 .7 5.8 5.8 0 0 1 2.7 2.1 6.2 6.2 0 0 1 1 3.2l-2.6.2a4.2 4.2 0 0 0-1.4-2.9 5.5 5.5 0 0 0-3.6-1 5.7 5.7 0 0 0-3.5 1 2.7 2.7 0 0 0-1.2 2 2.3 2.3 0 0 0 .8 1.9q.8.7 4 1.4a26.7 26.7 0 0 1 4.6 1.3 6.2 6.2 0 0 1 2.6 2.1 5 5 0 0 1 .9 2.9 5.5 5.5 0 0 1-1 3 6.1 6.1 0 0 1-2.6 2.3 9.3 9.3 0 0 1-4 .8 11.7 11.7 0 0 1-4.6-.8 6.5 6.5 0 0 1-3-2.4 6.9 6.9 0 0 1-1-3.7zM207 261v-20.3h2.7V261zM214.4 261v-20.3h2.8l10.6 16v-16h2.6V261h-2.7L217 245v16zM244.4 253v-2.3h8.7v7.5a15.2 15.2 0 0 1-4.1 2.4 12.1 12.1 0 0 1-4.4.8 11.6 11.6 0 0 1-5.4-1.3 8.5 8.5 0 0 1-3.7-3.7 11.7 11.7 0 0 1-1.2-5.4 12.6 12.6 0 0 1 1.2-5.6 8.3 8.3 0 0 1 3.6-3.8 11.2 11.2 0 0 1 5.3-1.2 10.6 10.6 0 0 1 4 .7 6.6 6.6 0 0 1 2.8 2 8.8 8.8 0 0 1 1.6 3.3l-2.5.7a7.5 7.5 0 0 0-1.1-2.5 4.7 4.7 0 0 0-2-1.4 7.1 7.1 0 0 0-2.8-.5 8.3 8.3 0 0 0-3.1.5 6 6 0 0 0-2.2 1.5 7 7 0 0 0-1.3 2 10.6 10.6 0 0 0-.8 4.1 10 10 0 0 0 1 4.5 6 6 0 0 0 2.7 2.8 8.4 8.4 0 0 0 3.8.9 9 9 0 0 0 3.4-.7 8.8 8.8 0 0 0 2.5-1.5v-3.7z"></path>
                            <path d="M18.8 278.1q0-5.9 3.2-9.2a10.8 10.8 0 0 1 8.2-3.4 11.4 11.4 0 0 1 5.9 1.6 10.3 10.3 0 0 1 4 4.4 14.2 14.2 0 0 1 1.4 6.3 14 14 0 0 1-1.5 6.5 10 10 0 0 1-4 4.3 11.8 11.8 0 0 1-5.9 1.5 11.2 11.2 0 0 1-6-1.6 10.4 10.4 0 0 1-4-4.4 13.4 13.4 0 0 1-1.3-6zm3.2 0a9.5 9.5 0 0 0 2.3 6.8 7.6 7.6 0 0 0 5.8 2.5A7.6 7.6 0 0 0 36 285q2.3-2.5 2.3-7a12.2 12.2 0 0 0-1-5.1 7.5 7.5 0 0 0-2.9-3.4 7.8 7.8 0 0 0-4.2-1.2 8 8 0 0 0-5.8 2.3q-2.4 2.3-2.4 7.7zM45.6 289.7v-23.8h9a21.6 21.6 0 0 1 3.5.3 7.2 7.2 0 0 1 3 1 5.8 5.8 0 0 1 1.9 2.4 7.7 7.7 0 0 1-1.2 8.3q-2 2.1-7 2.1h-6.1v9.7zm3.1-12.5h6.1q3.1 0 4.4-1.1a4 4 0 0 0 1.3-3.2 4.3 4.3 0 0 0-.8-2.6 3.5 3.5 0 0 0-2-1.4 13.4 13.4 0 0 0-3-.2h-6zM67.7 289.7v-23.8h9a21.6 21.6 0 0 1 3.6.3 7.2 7.2 0 0 1 3 1 5.8 5.8 0 0 1 1.8 2.4 7.7 7.7 0 0 1-1.2 8.3q-2 2.1-7 2.1h-6v9.7zm3.1-12.5H77q3 0 4.3-1.1a4 4 0 0 0 1.3-3.2 4.3 4.3 0 0 0-.8-2.6 3.5 3.5 0 0 0-2-1.4 13.4 13.4 0 0 0-2.9-.2h-6zM88.9 278.1q0-5.9 3.2-9.2a10.8 10.8 0 0 1 8.2-3.4 11.4 11.4 0 0 1 5.9 1.6 10.3 10.3 0 0 1 4 4.4 14.2 14.2 0 0 1 1.4 6.3 14 14 0 0 1-1.4 6.5 10 10 0 0 1-4.2 4.3 11.8 11.8 0 0 1-5.7 1.5 11.2 11.2 0 0 1-6-1.6 10.4 10.4 0 0 1-4-4.4 13.4 13.4 0 0 1-1.4-6zm3.2 0a9.5 9.5 0 0 0 2.3 6.8 8 8 0 0 0 11.7 0q2.3-2.5 2.3-7a12.2 12.2 0 0 0-1-5.1 7.5 7.5 0 0 0-2.9-3.4 7.8 7.8 0 0 0-4.2-1.2 8 8 0 0 0-5.8 2.3q-2.4 2.3-2.4 7.7zM115.7 289.7v-23.8h10.6a14 14 0 0 1 4.8.7 5.3 5.3 0 0 1 2.6 2.2 6.7 6.7 0 0 1 1 3.6 6 6 0 0 1-1.6 4.3 8.3 8.3 0 0 1-5 2.2 8.1 8.1 0 0 1 1.8 1.2 16.4 16.4 0 0 1 2.6 3.1l4.2 6.5h-4l-3.1-5-2.3-3.2a7.1 7.1 0 0 0-1.6-1.6 4.7 4.7 0 0 0-1.4-.6 9.4 9.4 0 0 0-1.8-.2H119v10.6zm3.2-13.3h6.7a10.1 10.1 0 0 0 3.4-.4 3.6 3.6 0 0 0 1.8-1.5 3.9 3.9 0 0 0 .7-2 3.5 3.5 0 0 0-1.2-2.9 5.7 5.7 0 0 0-4-1H119zM145 289.7v-21h-7.7V266H156v2.8h-7.9v21zM175 266h3v13.7a16.2 16.2 0 0 1-.7 5.7 7 7 0 0 1-3 3.4 10.4 10.4 0 0 1-5.5 1.3 11.4 11.4 0 0 1-5.5-1.2 6.6 6.6 0 0 1-3-3.3 15.9 15.9 0 0 1-1-6V266h3.2v13.7a13.4 13.4 0 0 0 .6 4.6 4.4 4.4 0 0 0 2 2.3 6.9 6.9 0 0 0 3.4.8q3.5 0 5-1.6t1.4-6zM183.3 289.7v-23.8h3.2l12.5 18.7v-18.7h3v23.8h-3.2L186.3 271v18.7zM207.8 289.7v-23.8h3.2v23.8zM222.6 289.7v-21h-7.9V266h18.9v2.8h-7.9v21zM243.5 289.7v-10l-9.2-13.8h3.8l4.7 7.2 2.4 4 2.6-4.2 4.6-7h3.7l-9.5 13.7v10.1z"></path>
                          </g>
                        </svg>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>

              <div className="footer-image-style">
                {/* <FooterImage/> */}
                <img src={FooterImage} />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Description;
